import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable,  throwError,  of } from 'rxjs';
import { environment } from '../../environments/environment';
import { catchError, map, switchMap } from 'rxjs/operators';



@Injectable({
    providedIn: 'root'
})
export class AzureAuthService {
    constructor(private _route: ActivatedRoute,
        private _http: HttpClient) { }

    // handleQueryParameters(): Observable<string | null> {
    //     return this._route.queryParams.pipe(
    //         switchMap(params => {
    //             if (params && params['code'] && params['session_state']) {
    //                 return this.acquireToken(params['code'], params['session_state']);
    //             } else {
    //                 return this.makeAuthRequest().then(url => {
    //                     window.location.href = url;
    //                     return null;
    //                 });
    //             }
    //         }),
    //         catchError(error => throwError(error))
    //     );
    // }

    handleQueryParameters(): Observable<string | null> {
        return this._route.queryParams.pipe(
          switchMap((params) => {
            if (params && params['code'] && params['session_state']) {
              return this.acquireToken(params['code'], params['session_state']);
            } else {
              return this.makeAuthRequest().then((url) => {
                if (url) {
                  window.location.href = url;
                }
                return null;
              });
            }
          }),
          catchError((error) => throwError(error))
        );
      }

    private async makeAuthRequest(): Promise<string> {
        const codeVerifier = this.generateRandomCodeVerifier();
        const codeChallenge = await this.createCodeChallenge(codeVerifier);
        sessionStorage.setItem('codeVerifier', codeVerifier);
        sessionStorage.setItem('codeChallenge', codeChallenge);
debugger
console.log('Full Environment Object:', environment);
console.log('Type of Environment:', typeof environment);
console.log('MSAL Config:', environment.msalConfig);

console.log('Does `msalConfig` exist?', 'msalConfig' in environment);
console.log('MSAL Config:', environment.msalConfig);
console.log('Token URL:', environment?.msalConfig?.auth?.tokenURL);
        const url = `${environment.msalConfig.auth.authURL}?client_id=${environment.msalConfig.auth.clientId}&redirect_uri=${environment.RedirectUri}&scope=user.read&response_type=code&response_mode=query&code_challenge=${codeChallenge}&code_challenge_method=S256`;
        console.log('Token URL:', url);

        return url;
    }

    private acquireToken(code: string, sessionState?: string): Observable<string | null> {
        const codeVerifier = sessionStorage.getItem('codeVerifier');
        const codeChallenge = sessionStorage.getItem('codeChallenge');
        if (!codeVerifier || !codeChallenge) {
            throw new Error('Missing code verifier or code challenge');
        }
        debugger;
        console.log('Environment Object:', environment);
        console.log('MSAL Config:', environment.msalConfig);
        console.log('Token URL:', environment.msalConfig?.auth?.tokenURL);
        const formData = new FormData();
        formData.append('client_id', environment.msalConfig.auth.clientId);
        formData.append('redirect_uri', environment.RedirectUri);
        formData.append('code', code);
        formData.append('grant_type', 'authorization_code');
        formData.append('code_verifier', codeVerifier);
        formData.append('code_challenge', codeChallenge);
        formData.append('code_challenge_method', 'S256');

        if (sessionState) {
            formData.append('state', sessionState);
        }

        return this._http.post<any>(environment.msalConfig.auth.tokenURL, formData).pipe(
            map(response => response.access_token),
            catchError(error => {
                console.error('Error acquiring token', error);
                return of(null);
            })
        );
    }

    private generateRandomCodeVerifier(): string {
        const array = new Uint32Array(56 / 2);
        window.crypto.getRandomValues(array);
        return Array.from(array, dec => ('0' + dec.toString(16)).substr(-2)).join('');
    }

    private async createCodeChallenge(codeVerifier: string): Promise<string> {
        const encoder = new TextEncoder();
        const data = encoder.encode(codeVerifier);
        const digest = await window.crypto.subtle.digest("SHA-256", data);
        return this.base64urlencode(digest);
    }

    private base64urlencode(a: ArrayBuffer): string {
        const bytes = new Uint8Array(a);
        const byteArr = Array.from(bytes); // Convert to regular array
        return btoa(String.fromCharCode(...byteArr)) // Spread the regular array
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=+$/, '');
    }
}
